import { isArrayEmpty } from "../../omnia"
import { parseFieldKey } from "../fields"
import { MapContext } from "./mapContext"

export function usePointsViewer(fieldKey: string, showPoints: boolean, mapContext: MapContext, visibleLayers: number[]) {

    const fieldId = fieldKey ? parseFieldKey(fieldKey) : 0

    React.useEffect(() => {

        if (mapContext?.map) {
            updateVisiblePoints(fieldId, showPoints, mapContext, visibleLayers)
        }

    }, [mapContext, fieldId, showPoints, visibleLayers])

}

function updateVisiblePoints(fieldId: number, showPoints: boolean, mapContext: MapContext, visibleLayers: number[]) {

    const set = new Set(visibleLayers)

    const layers = mapContext.map.getDataLayers(l => set.has(l.datalayerId))

    if (isArrayEmpty(layers)) {
        return
    }

    for (const l of layers) {
        const show = showPoints && (l.fieldId === fieldId)
        l.showPoints(show, mapContext.map, true)
    }

}
